import { TabsUIState, TabsUIActions, TabsUIStore, TABS_UI_INITIAL_STATE } from './tabsUI.types';

type SetState = (
  partial:
    | TabsUIStore
    | Partial<TabsUIStore>
    | ((state: TabsUIStore) => TabsUIStore | Partial<TabsUIStore>),
  replace?: boolean
) => void;
type GetState = () => TabsUIStore;

export const createTabsUIActions = (set: SetState, get: GetState): TabsUIActions => ({
  setSelectedTabId: (id) => set({ selectedTabId: id }),
  setViewMode: (mode) => {
    const isTablesToList = get().viewMode === 'tables' && mode === 'list';
    set(
      isTablesToList
        ? {
            viewMode: mode,
            selectedTabId: null,
            isTabDetailsModalOpen: false,
          }
        : { viewMode: mode },
    );
  },
  setCategoryTabsMode: (mode) => set({ categoryTabsMode: mode }),
  setIsTablesLocked: (locked) => set({ isTablesLocked: locked }),
  setIsNewTabOpen: (open) => set({ isNewTabOpen: open }),
  setIsProductCatalogOpen: (open) => set({ isProductCatalogOpen: open }),
  setIsTableModalOpen: (open) => set({ isTableModalOpen: open }),
  setIsTabDetailsModalOpen: (open) => set({ isTabDetailsModalOpen: open }),
  setIsCloseTabOpen: (open) => set({ isCloseTabOpen: open }),
  setIsSplitTabOpen: (open) => set({ isSplitTabOpen: open }),
  setSelectedPaymentMethods: (methods) => set({ selectedPaymentMethods: methods }),
  setNewCustomerName: (name) => set({ newCustomerName: name }),
  setNewCustomerDiscount: (discount) => set({ newCustomerDiscount: discount }),
  setDiscountInput: (value) => set({ discountInput: value }),
  setItemDiscountInputs: (value) =>
    set((state: TabsUIState) => ({
      itemDiscountInputs:
        typeof value === 'function' ? value(state.itemDiscountInputs) : value,
    })),
  setPendingAssignTableId: (id) => set({ pendingAssignTableId: id }),
  setPendingSaleForInvoice: (sale) => set({ pendingSaleForInvoice: sale }),
  setCurrentRoomId: (roomId) => set({ currentRoomId: roomId }),

  closeTabSelection: () =>
    set({ selectedTabId: null, isCloseTabOpen: false }),

  clearPendingSaleForInvoice: () => set({ pendingSaleForInvoice: null }),

  resetTabsUIState: () => set(TABS_UI_INITIAL_STATE),
});
